import isString from "./isString";
var isEmptyString = function isEmptyString(value) {
  if (!isString(value) || typeof value === "undefined") {
    return false;
  }
  return value.length === 0;
};
export default isEmptyString;